const EmailSuccessNotification = () => {
  return <div className="div"></div>;
};

export default EmailSuccessNotification;
